<template>
  <DefaultLayout
    :pageTitle="meta.title"
    :pageDescription="meta.description"
    :showFooterCTA="true"
  >
    <PageHeader
      title="eBooks"
      subtitle-text="Free, in-depth guides on email, SMS and marketing automation — download and keep."
      class="mb-0 no-submenu"
    ></PageHeader>

    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12">
          <div class="hub__grid mt-10 mb-20">
            <a class="hub__card" href="#" v-for="ebook in ebooks" v-bind:key="ebook.title">
              <div class="hub__card-media" v-bind:class="'hub__card-media--' + (ebook.color || 'blue')">
                <CardIllustration type="eBook"></CardIllustration>
              </div>
              <div class="hub__card-body">
                <span class="hub__card-type" v-bind:class="'hub__card-type--' + (ebook.color || 'blue')">Free download</span>
                <p class="hub__card-title">{{ ebook.title }}</p>
                <div class="hub__card-meta">{{ ebook.meta }}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout";
import PageHeader from "@/components/Header/PageHeader";
import CardIllustration from "@/components/ContentHub/CardIllustration";

export default {
  name: "EbooksPage",
  components: {
    DefaultLayout,
    PageHeader,
    CardIllustration,
  },
  data() {
    return {
      meta: {
        title: "eBooks",
        description:
          "Free, in-depth guides on email, SMS and marketing automation — download and keep.",
      },
      ebooks: [
        { title: "The SMB Marketing Blueprint", meta: "24 pages · PDF", color: "yellow" },
        { title: "The Ultimate Guide to Email Deliverability", meta: "32 pages · PDF" },
        { title: "AI in Marketing: 2026 Playbook", meta: "28 pages · PDF" },
        { title: "SMS Marketing Compliance Checklist", meta: "12 pages · PDF" },
        { title: "Building Your First Automation Workflow", meta: "20 pages · PDF" },
      ],
    };
  },
};
</script>
